import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DatePickerComponent implements OnInit {
  @Output() public dateChange: EventEmitter<Date> = new EventEmitter<Date>();
  constructor() { }
  noOfdays: number[] = [];
  months: string[] = ["January", "Februray", "March", "April", "May", "June", "July", "August", "September", "October", "November","December"];
  @Input() formSubmitted: boolean;
  @Input() minYear: number = 0;
  @Input() maxYear: number = 0;
  @Input() customIndex: number=0;
  years: number[] = [];
  @Input() selectedYear: number=0;
  @Input() selectedMonth: number=0;
  @Input() selectedDate: number=0;
  @Input() readOnly : boolean; 
  ngOnInit() {
    //if not set make it 100 years back
    if (this.minYear == 0) {
      this.minYear = new Date().getFullYear() - 100;
    }
    //if not set make it current year
    if (this.maxYear == 0) {
      this.maxYear = new Date().getFullYear();
    }
    // !this.selectedYear && (this.selectedYear = this.maxYear);
    // !this.selectedMonth && (this.selectedMonth = new Date().getMonth())
    // !this.selectedDate && (this.selectedDate = new Date().getDay())
    for (var i = this.minYear; i <= this.maxYear; i = i + 1) {
      this.years.push(i);
    }
    this.calculateNoOfDays();
    //if(this.selectedYear && this.selectedMonth && this.selectedDate)
    this.dateChange.emit(new Date(this.selectedYear, this.selectedMonth, this.selectedDate))
  }

  calculateNoOfDays() {
    this.noOfdays = [];
    var totalNoOfDays = this.getDaysInMonth(this.selectedMonth + 1, this.selectedYear);
    for (var i = 1; i <= totalNoOfDays; i++) {
      this.noOfdays.push(i);
    }
    //if earlier date selected invalid then reset it to 1
    if (this.selectedDate > this.noOfdays[this.noOfdays.length - 1]) {
      this.selectedDate = 1;
    }
  }

  onSelectionChanged() {
    this.calculateNoOfDays();
    this.dateChange.emit(new Date(this.selectedYear, this.selectedMonth, this.selectedDate))
  }
  getDaysInMonth(month: number, year: number) {
    // Here January is 1 based
    //Day 0 is the last day in the previous month
    if(year > 0 && month > 0)
    return new Date(year, month, 0).getDate();
    else{
      return 30;
    }
  };

}
